import type { NavigateFunction } from 'react-router-dom';
import { isNativeAndroid, sendToNative } from './NativeUtil';
import saveData from './saveData';

interface CompleteAuthLoginParams {
  response: Record<string, unknown>;
  navigate: NavigateFunction;
  fallbackEmail?: string;
}

function notifyNativeLogin() {
  if (isNativeAndroid() && window.Android) {
    // TODO: Android 확인필요
    return;
  }
  sendToNative('{"type": "login"}');
}

export function completeAuthLogin({
  response,
  navigate,
  fallbackEmail = ''
}: CompleteAuthLoginParams): boolean {
  const userId = typeof response.userId === 'string' ? response.userId : '';
  const jwt = typeof response.jwt === 'string' ? response.jwt : '';
  const email =
    typeof response.email === 'string' && response.email.trim() !== ''
      ? response.email
      : fallbackEmail;

  if (!userId || !jwt) {
    return false;
  }

  saveData('userId', userId);
  saveData('email', email);
  saveData('token', JSON.stringify(jwt));

  const newUser = response.newUser === true;
  const hasProfiles = response.hasProfiles === true;
  const likedArtists = Array.isArray(response.likedArtists) ? response.likedArtists : [];
  const likedArtistsEmpty = likedArtists.length === 0;
  const localeCountryUpdateRequired = response.localeCountryUpdateRequired === true;
  const shouldOpenLocaleCountrySetting = localeCountryUpdateRequired || newUser;
  const shouldOpenNicknameSetting = newUser || likedArtistsEmpty || !hasProfiles;
  const nextPathAfterLocaleCountrySetting = shouldOpenNicknameSetting
    ? '/nickname-setting?init=true'
    : '/home';

  if (shouldOpenLocaleCountrySetting) {
    notifyNativeLogin();
    navigate('/locale-country-setting?init=true', {
      replace: true,
      state: {
        requireLocaleCountryUpdate: localeCountryUpdateRequired,
        nextPath: nextPathAfterLocaleCountrySetting
      }
    });
    return true;
  }

  if (shouldOpenNicknameSetting) {
    navigate('/nickname-setting?init=true', { replace: true });
    return true;
  }

  if (hasProfiles) {
    navigate('/home', {
      state: {
        redirectUrl: '/home'
      },
      replace: true
    });
    notifyNativeLogin();
    return true;
  }

  navigate('/nickname-setting?init=true', { replace: true });
  return true;
}
